// Mock data for the website

export const therapyTypes = [
  {
    id: 1,
    title: 'טיפול משפחתי',
    description: 'טיפול משפחתי יכול לעזור למשפחות להתמודד עם קשיים ואתגרים, ולחזק את הקשרים המשפחתיים',
    imageSrc: 'https://images.unsplash.com/photo-1484973768669-7fb6b5451095',
    link: '/family',
    fullDescription: `טיפול משפחתי עוסק במערכת היחסים המשפחתית כמערכת שלמה, ומושתת על התפיסה כי המשפחה היא יחידה אחת שבה כל אחד מבני המשפחה משפיע ומושפע מהאחרים.

הטיפול המשפחתי מתאים במקרים של:
• קשיים בתקשורת בתוך המשפחה
• התמודדות עם משברים (כמו גירושין, אובדן, מחלה)
• התמודדות עם שינויים במבנה המשפחתי
• קשיים בגידול ילדים והתמודדות עם התנהגויות מאתגרות
• מעברים משמעותיים בחיי המשפחה
• סכסוכים בין אחים
• קשיים ביחסים בין הורים לילדים מתבגרים

במסגרת הטיפול המשפחתי, אני עובדת עם כל בני המשפחה, או חלקם, בהתאם לצורך ולמטרות הטיפול. הטיפול מאפשר יצירת שיח פתוח ובטוח, הבנת דפוסי תקשורת וקשר, ופיתוח דרכי התמודדות יעילות יותר.`
  },
  {
    id: 2,
    title: 'טיפול זוגי',
    description: 'טיפול זוגי מסייע לזוגות לשפר את התקשורת ביניהם ולהתמודד עם משברים ואתגרים בקשר',
    imageSrc: 'https://images.unsplash.com/photo-1527628173875-3c7bfd28ad78',
    link: '/couple',
    fullDescription: `טיפול זוגי מתמקד במערכת היחסים הזוגית ומסייע לזוגות לשפר את הקשר ביניהם, להתמודד עם קשיים ומשברים, ולבנות יחסים בריאים ומספקים יותר.

הטיפול הזוגי מתאים במקרים של:
• קשיי תקשורת בין בני הזוג
• משברי אמון וקנאה
• התמודדות עם בגידה
• משברים בשלבים שונים של הקשר
• שחיקה וריחוק רגשי
• התמודדות עם שינויים משמעותיים (הורות, פרישה)
• חוסר איזון בזוגיות
• קשיים בתחום האינטימיות

במסגרת הטיפול, אני מסייעת לבני הזוג להבין את הדפוסים שנוצרו בקשר, לשפר את התקשורת, להעמיק את ההבנה והאמפתיה ההדדית, ולפתח דרכים חדשות להתמודדות עם האתגרים העומדים בפניהם.`
  },
  {
    id: 3,
    title: 'טיפול אישי',
    description: 'טיפול אישי מאפשר התמודדות עם אתגרים רגשיים ונפשיים שונים ומסייע בפיתוח כלים ומיומנויות להתמודדות',
    imageSrc: 'https://images.unsplash.com/photo-1592947945242-69312358628b',
    link: '/personal',
    fullDescription: `טיפול אישי מתמקד בתהליכים נפשיים ורגשיים של האדם, ומסייע בהתמודדות עם קשיים שונים, פיתוח מודעות עצמית, ושיפור איכות החיים.

הטיפול האישי מתאים במקרים של:
• חרדה ומתח
• דיכאון ומצבי רוח
• משברי חיים ומעברים
• אובדן וכאב
• קשיים בהסתגלות
• דימוי עצמי נמוך
• קשיים ביחסים בינאישיים
• התמודדות עם טראומה

במסגרת הטיפול האישי, אני מעניקה מרחב מוגן ומכיל שבו ניתן לחקור רגשות, מחשבות והתנהגויות, תוך הבנה מעמיקה יותר של עצמך. הטיפול מאפשר פיתוח מודעות, כלים להתמודדות, ותהליכי צמיחה והתפתחות אישית.`
  }
];

export const audioTracks = [
  {
    id: 1,
    title: "מדיטציה מודרכת - הרפיה עמוקה",
    description: "מדיטציה להרגעת הגוף והנפש, אורך: 10 דקות",
    audioSrc: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
  },
  {
    id: 2,
    title: "תרגיל נשימות להרגעה מיידית",
    description: "תרגיל קצר לשליטה בחרדה, אורך: 5 דקות",
    audioSrc: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3"
  },
  {
    id: 3,
    title: "הדרכה - תקשורת זוגית אפקטיבית",
    description: "הרצאה על עקרונות תקשורת בריאה, אורך: 15 דקות",
    audioSrc: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3"
  }
];

export const aboutContent = {
  title: "שרון וייספלד - פסיכולוגית מומחית",
  image: "https://i.imgur.com/kinvRWg.png",
  paragraphs: [
    "שלום, שמי שרון וייספלד, אני פסיכולוגית מומחית עם התמחות בטיפול משפחתי, זוגי ואישי. בעלת תואר שני בפסיכולוגיה קלינית ותעודת מומחיות מטעם משרד הבריאות.",
    "במשך למעלה מעשר שנים אני מלווה אנשים בתהליכי שינוי, צמיחה והתמודדות עם אתגרי החיים השונים. הגישה הטיפולית שלי משלבת אלמנטים מגישות טיפוליות שונות, ומותאמת באופן אישי לצרכים הייחודיים של כל מטופל ומטופלת.",
    "אני מאמינה כי לכל אדם יש את הכוחות והמשאבים להתמודד עם האתגרים שהחיים מזמנים לו, ותפקידי כמטפלת הוא לסייע בגילוי ופיתוח המשאבים הללו.",
    "הקליניקה שלי ממוקמת בהוד השרון, בסביבה שקטה ונעימה המאפשרת פרטיות מלאה. אני מקבלת מטופלים מכל הגילאים, רקעים ואוכלוסיות."
  ],
  education: [
    "תואר שני בפסיכולוגיה קלינית, אוניברסיטת תל אביב",
    "התמחות בטיפול משפחתי וזוגי, מכון שינוי",
    "הכשרה בטיפול ממוקד רגש (EFT)",
    "הכשרה בטיפול קוגניטיבי-התנהגותי (CBT)"
  ],
  approach: [
    "הגישה הטיפולית שלי משלבת אלמנטים מגישות טיפוליות שונות, כגון:",
    "• גישה דינמית המתמקדת בהבנת דפוסים ותהליכים נפשיים",
    "• גישה מערכתית הבוחנת את מערכות היחסים והקשרים",
    "• כלים קוגניטיביים-התנהגותיים לשינוי דפוסי חשיבה והתנהגות",
    "• טיפול ממוקד רגש לעבודה על צרכים רגשיים ודפוסי התקשרות"
  ]
};